import { useTransition } from '../../hooks/useTransition';
import './LandingOverlay.css';

export default function LandingOverlay() {
  const { navigateWithTransition } = useTransition();

  return (
    <div className="landing-overlay">
      <div className="landing-content">
        <h1 className="landing-title">Adriel Arias</h1>
        <p className="landing-subtitle">
          Senior Software Engineer | .NET, Cloud & Full-Stack Systems
        </p>

        <nav className="landing-nav">
          <button className="nav-button" onClick={() => navigateWithTransition('/projects')}>
            Projects
          </button>
          <button className="nav-button" onClick={() => navigateWithTransition('/about')}>
            About
          </button>
          <button className="nav-button" onClick={() => navigateWithTransition('/contact')}>
            Contact
          </button>
        </nav>
      </div>
    </div>
  );
}
